<template>
    <div class="carBox carBoxLeft">
        <el-alert
            title="权限异常"
            type="warning"
            description="未获得访问权限，请联系管理员！"
            show-icon
            :closable="false">
        </el-alert>
    </div>
    
</template>

<script>
export default {
    name: "jurisdiction",
}
</script>